// Primeiro import do bundle, de proposito: instala os handlers de erro antes
// de qualquer modulo da aplicacao ser avaliado.
import './instrument';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);

